module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header-3fa6884b8bd2a20bffec9fa0c4a33b89.jpg";